var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgJointacademySymbol({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 32,
    viewBox: "0 0 26 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8057 0C15.1353 0.0419397 16.999 1.92923 16.9567 4.19397C16.9143 6.45872 15.093 8.26212 12.8057 8.30406C10.476 8.26212 8.61232 6.37484 8.65467 4.11009C8.65467 1.84535 10.5184 0 12.8057 0ZM12.0856 11.6592C15.0506 10.8624 18.058 14.2595 15.5165 18.2018C13.8222 20.844 14.6694 23.1507 13.1022 23.5701C10.3913 24.1992 6.19796 13.1691 12.0856 11.6592ZM0.47974 8.68152C-0.70626 10.0655 0.352669 12.54 3.14824 12.1625C5.01196 11.9528 6.07089 12.9594 6.66389 12.2464C7.72282 10.9882 2.76703 5.95544 0.47974 8.68152ZM2.21638 25.8768C1.19981 24.7025 2.13167 22.5636 4.50367 22.8991C6.11324 23.1088 7.0451 22.1861 7.51103 22.8571C8.48524 23.9476 4.20717 28.2254 2.21638 25.8768ZM24.581 5.15858C26.1905 6.62647 25.3434 9.73001 21.9548 9.73001C19.6675 9.73001 18.6086 11.156 17.7615 10.3591C16.3213 8.9751 21.4042 2.2228 24.581 5.15858ZM19.5828 31.4548C21.1924 30.7418 21.3618 28.2254 18.8204 27.3028C17.1261 26.6737 16.6602 25.3316 15.813 25.709C14.3305 26.3381 16.3637 32.7969 19.5828 31.4548Z",
    fill: "#307FE2"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJointacademySymbol);
export default __webpack_public_path__ + "static/media/jointacademy_symbol.ac9f08affc92a25015ba85914c27ceb7.svg";
export { ForwardRef as ReactComponent };